export const gossipCategories = [
  {
    slug: "entertainment-gossip",
    name: "娱乐八卦",
    tagline: "圈内风向第一条",
    description:
      "把散落在各处的圈内消息整理成一条清晰线索，从杀青宴到录制现场，帮你判断哪条瓜正在发酵，哪条只是空穴来风。",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20backstage%20corridor%20with%20warm%20vintage%20lamps%20and%20velvet%20curtains%2C%20cinematic%20blur%2C%20stylized%20editorial%20entertainment%20atmosphere%2C%20no%20people%2C%20rich%20amber%20tones%2C%20soft%20grain&width=800&height=560&seq=gua-cat-gossip-01&orientation=landscape",
  },
  {
    slug: "star-news",
    name: "明星动态",
    tagline: "行程与作品实时跟进",
    description:
      "巡演加场、专辑预热、公开活动亮相，明星动态栏目盯住艺人每一次对外动作，把行程变化和作品节奏讲清楚。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20concert%20stage%20before%20showtime%20with%20rows%20of%20warm%20lights%20and%20haze%2C%20stylized%20cinematic%20scene%2C%20no%20people%2C%20deep%20crimson%20and%20amber%20tones%2C%20dreamy%20bokeh&width=800&height=560&seq=gua-cat-star-02&orientation=landscape",
  },
  {
    slug: "film-tv",
    name: "影视综艺",
    tagline: "剧综口碑与幕后",
    description:
      "剧集更新节奏、综艺改版反响、档期排片变化，影视综艺栏目关注作品本身的质量讨论，而不只是热闹。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20film%20projector%20beam%20in%20dark%20screening%20room%20with%20dusty%20light%20rays%2C%20cinematic%20editorial%20mood%2C%20no%20people%2C%20warm%20gold%20and%20charcoal%20tones&width=800&height=560&seq=gua-cat-filmtv-03&orientation=landscape",
  },
  {
    slug: "hot-topics",
    name: "网络热点",
    tagline: "全网正在讨论什么",
    description:
      "话题词条为什么突然冲榜、二次传播是怎么起来的、跨界联名为何被抢空，网络热点栏目拆解热度背后的推手。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20neon%20city%20night%20blur%20with%20warm%20orange%20and%20coral%20reflections%20on%20wet%20glass%2C%20stylized%20editorial%20energy%2C%20no%20people%2C%20moody%20contrast&width=800&height=560&seq=gua-cat-hot-04&orientation=landscape",
  },
  {
    slug: "music-live",
    name: "音乐现场",
    tagline: "演出与现场实录",
    description:
      "音乐节、巡演、livehouse 的现场表现与观众反馈，音乐现场栏目记录舞台上的真实瞬间与台下的真实评价。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20amber%20spotlights%20hitting%20a%20microphone%20stand%20on%20an%20empty%20stage%20with%20smoke%2C%20stylized%20cinematic%20editorial%20scene%2C%20no%20people%2C%20crimson%20and%20gold%20tones&width=800&height=560&seq=gua-cat-music-05&orientation=landscape",
  },
];